<template>
  <div class="pricing-page">
    <h1 class="title">Pricing</h1>
    <div class="underline"></div>
    <p class="subtitle">
      Medlab offers packages designed for every type of laboratory ranging from independent diagnostics to large networks. 
      Each plan equips you with the tools to streamline workflows, minimize errors, and deliver results faster and more accurately.
    </p>

    <!-- Pricing Cards -->
    <div class="pricing-container">
      <!-- Basic Version -->
      <div class="pricing-card">
        <img src="@/assets/icons/Best_seller_icon.svg" alt="Best Seller" class="best-seller-img" />
        <h3>Basic Version</h3>
        <p class="price">₹14000 <span>/ One-Time Setup</span></p>
        
        <ul>
          <li><span class="tick">✔</span> Lab Management</li>
          <li><span class="tick">✔</span> WhatsApp Link</li>
          <li><span class="tick">✔</span> PDF Reports</li>
          <li><span class="tick">✔</span> Online/Offline Version</li>
          <li><span class="tick">✔</span> Abnormal Validation</li>
          <li><span class="tick">✔</span> Auto Calculations</li>
          <li><span class="tick">✔</span> Basic Designer Support</li>
          <li><span class="tick">✔</span> Test Result Comparison Option</li>
        </ul>
        <div class="amc-footer">AMC ₹2500</div>
      </div>

      <!-- Pro Version -->
      <div class="pricing-card">
        <h3>Pro Version</h3>
        <p class="price">₹20000 <span>/ One-Time Setup</span></p>
        <ul>
          <li><span class="tick">✔</span> All Basic Features</li>
          <li><span class="tick">✔</span> SMS Option</li>
          <li><span class="tick">✔</span> Machine Interface and Integration</li>
          <li><span class="tick">✔</span> User-Based Privilege</li>
          <li><span class="tick">✔</span> Result Approval Option</li>
        </ul>
        <div class="amc-footer">AMC ₹3000</div>
      </div>

      <!-- Enterprise Branch -->
      <div class="pricing-card">
        <h3>Enterprise Branch</h3>
        <p class="price1">₹14000 <span>/ Main Branch</span></p>
        <p class="price">₹10000 <span>/ Per Branch</span></p>
        <ul>
          <li><span class="tick">✔</span> All Basic Features</li>
          <li><span class="tick">✔</span> SMS Option</li>
          <li><span class="tick">✔</span> Machine Interface and Integration</li>
          <li><span class="tick">✔</span> User-Based Privilege</li>
          <li><span class="tick">✔</span> Result Approval Option</li>
          <li><span class="tick">✔</span> Multi-Branch Support</li>
        </ul>
        <div class="amc-footer">AMC ₹2500 / Branch</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PricingPage"
};
</script>

<style scoped>
.pricing-page {
  text-align: center;
  padding: 40px 20px;
  background: #fff;
}
.title {
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 50px;
  color: #206A98;
}

.underline {
  width: 10%;
  height: 3px;
  background: #206A98;
  margin: 0 auto 40px;
  border-radius: 2px;
}

.subtitle {
  font-size: 18px;
  color: #333;
  max-width: 800px;
  margin: 0 auto 30px;
  line-height: 1.6;
}
.pricing-container {
  display: flex;
  justify-content: center;
  gap: 25px;
  flex-wrap: wrap;
}

.pricing-card {
  background: #fff;
  border: 1px solid #009886;
  border-radius: 12px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.08);
  padding: 25px;
  width: 320px;
  max-width: 100%;
  text-align: left;
  position: relative;
  transition: 0.3s;
  display: flex;
  flex-direction: column;
}

.pricing-card:hover {
  transform: translateY(-5px);
}

 .best-seller-img {
  position: absolute;
  top: 20px;
  right: 15px;
  width: 100px;
  height: auto;
  z-index: 10;
}


.pricing-card h3 {
  font-weight: bold;
  font-size: 1.5rem;
  margin-bottom: 10px;
  color: #222;
}

.price {
  font-size: 1.5rem;
  font-weight: bold;
  margin: 8px 0;
  color: #222;
  padding-bottom: 6px;
  border-bottom: 2px solid #777; /* underline like in image */
  display: inline-block;
}
.price1 { font-size: 20px; 
  font-weight: bold; 
  margin: 8px 0; 
  color: #222; } 
.price1 span { 
  font-size: 14px; 
  font-weight: normal; 
  color: #777; }

.price span {
  font-size: 1rem;
  font-weight: normal;
  color: #777;
}

ul {
  list-style: none;
  padding-left: 0;
  margin: 15px 0 20px;
}

li {
  margin: 8px 0;
  line-height: 1.5;
  color: #444;
  font-size: 1rem;
  display: flex;
  align-items: center;
}

.tick {
  color: #009886; /* green tick */
  font-weight: bold;
  margin-right: 8px;
  font-size: 16px;
}

.amc-footer {
  background: #009886;
  color: #fff;
  text-align: center;
  font-weight: bold;
  padding: 12px 16px;
  border-radius: 0 0 12px 12px;
  margin: -25px;
  margin-top: auto;
  transition: 0.3s;
}

@media (max-width: 768px) {
  .pricing-container {
    flex-direction: column;
    align-items: center;
  }

  .pricing-card {
    width: 100%;
    max-width: 380px;
  }
}
</style>


